import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiBookOpen, FiClock, FiHeart } = FiIcons;

const tips = [
  {
    icon: FiBookOpen,
    title: '做好功課',
    description: '提前了解餐廳特色、預算範圍，並提前預約。好的開始是成功的一半。',
    gradient: 'from-blue-500 to-cyan-500'
  },
  {
    icon: FiClock,
    title: '保持開放',
    description: '以開放的心態接受廚師的安排，相信他們的專業判斷與創意。',
    gradient: 'from-purple-500 to-pink-500'
  },
  {
    icon: FiHeart,
    title: '享受過程',
    description: '專注於當下，細細品味每一道菜，感受食材與技藝的完美結合。',
    gradient: 'from-rose-500 to-orange-500'
  }
];

function ExperienceSection() {
  return (
    <section id="experience" className="py-24">
      <div className="container-custom">
        {/* 🚀 優化：減少動畫時間 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            初次體驗指南
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
            三個關鍵要點，讓您的第一次 Omakase 體驗完美無憾
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {tips.map((tip, index) => (
            <motion.div
              key={tip.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="relative group"
            >
              <div className="card p-8 relative h-full">
                <motion.div
                  className={`absolute inset-0 rounded-xl bg-gradient-to-br ${tip.gradient} opacity-0 group-hover:opacity-5 transition-opacity -z-10`}
                />
                
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 10 }}
                  className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${tip.gradient} p-4 mb-6 shadow-lg`}
                >
                  <SafeIcon icon={tip.icon} className="w-full h-full text-white" />
                </motion.div>
                <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">
                  {tip.title}
                </h3>
                <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                  {tip.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExperienceSection;